import * as React from "react";

import type { DesignaliProps } from "../../types";

export const AiUser = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M17.72,6.78c-.06-.25-.26-.44-.51-.51l-2.17-.56c-.09-.03-.15-.12-.12-.22.02-.06.06-.11.12-.12l2.17-.56c.25-.06.44-.26.51-.51l.56-2.17c.03-.09.12-.15.22-.12.06.02.11.06.12.12l.56,2.17c.06.25.26.44.51.51l2.17.56c.09.03.15.12.12.22-.02.06-.06.11-.12.12l-2.17.56c-.25.06-.44.26-.51.51l-.56,2.17c-.03.09-.12.15-.22.12-.06-.02-.11-.06-.12-.12l-.56-2.17Z" />
        <path
          fill="none"
          d="M22,9.25v10.75c0,1.1-.9,2-2,2H4c-1.1,0-2-.9-2-2V4c0-1.1.9-2,2-2h10.68"
        />
        <circle cx="12" cy="10.9" r="2.45" />
        <path
          fill="none"
          d="M16.77,18.12c0-2.64-2.14-4.77-4.77-4.77s-4.77,2.14-4.77,4.77"
        />
      </svg>
    );
  },
);

export default AiUser;
